export const CORP_HANJINAPI = {
  displayName: "한진(아마존)",
  senderName: "한진(배송원직접추가)",
  corpUser: "hanjinapi",
  spotCode: "10480",
};

export const CORP_KURLYPROD = {
  displayName: "컬리나우",
  senderName: "컬리나우",
  corpUser: "kurlyProd",
  spotCode: "80004",
};

export const CORP_OLIVEYOUNG = {
  displayName: "올리브영",
  senderName: "올리브영",
  corpUser: "cjoyapi",
  spotCode: "",
};

export const CORP_ETC = {
  displayName: "직접입력",
  senderName: "",
  corpUser: "직접입력",
  spotCode: "직접입력",
};

export const CORP_OLIVEYOUNG_MFC = [
  {
    name: "경기군포MFC",
    spotCode: "10499",
  },
  {
    name: "경기부천MFC",
    spotCode: "10540",
  },
  {
    name: "경기성남MFC",
    spotCode: "10520",
  },
  {
    name: "경기고양MFC",
    spotCode: "10628",
  },
  {
    name: "경기여주MFC",
    spotCode: "10700",
  },
  {
    name: "경기오산MFC",
    spotCode: "10721",
  },
  {
    name: "경북경주MFC",
    spotCode: "10579",
  },
  {
    name: "부산해운대MFC",
    spotCode: "10549",
  },
  {
    name: "부산사상MFC",
    spotCode: "10561",
  },
  {
    name: "서울송파MFC",
    spotCode: "10427",
  },
  {
    name: "서울관악MFC",
    spotCode: "10332",
  },
  {
    name: "서울성북MFC",
    spotCode: "10426",
  },
  {
    name: "서울강서MFC",
    spotCode: "10593",
  },
  {
    name: "서울구로MFC",
    spotCode: "10638",
  },
  {
    name: "서울서초MFC",
    spotCode: "10667",
  },
  {
    name: "서울강동MFC",
    spotCode: "10666",
  },
  {
    name: "서울종로MFC",
    spotCode: "10670",
  },
  {
    name: "서울도봉MFC",
    spotCode: "10698",
  },
  {
    name: "서울서대문MFC",
    spotCode: "10699",
  },
  {
    name: "인천MFC",
    spotCode: "10576",
  },
  {
    name: "전북전주MFC",
    spotCode: "10574",
  },
  {
    name: "광주MFC",
    spotCode: "10589",
  },
  {
    name: "전남순천MFC",
    spotCode: "10734",
  },
  { name: "대전MFC", spotCode: "10645" },
  {
    name: "충북청주MFC",
    spotCode: "10662",
  },
  { name: "대구경산MFC", spotCode: "10684" },
  { name: "제주MFC", spotCode: "10703" },
];

export const CORP_OLIVEYOUNG_NFC = [
  {
    name: "올리브영NFC마포오늘드림",
    spotCode: "10705",
  },
  {
    name: "올리브영NFC성북오늘드림",
    spotCode: "10706",
  },
  {
    name: "올리브영광주오늘드림",
    spotCode: "10672",
  },
  {
    name: "올리브영대전오늘드림",
    spotCode: "10658",
  },
  {
    name: "올리브영여주오늘드림",
    spotCode: "10701",
  },
  {
    name: "올리브영전주오늘드림",
    spotCode: "10625",
  },
  {
    name: "올리브영청주오늘드림",
    spotCode: "10663",
  },
  {
    name: "올리브영순천오늘드림",
    spotCode: "10735",
  },
  {
    name: "올리브영군산오늘드림",
    spotCode: "10737",
  },
  {
    name: "올리브영NFC성수오늘드림",
    spotCode: "10738",
  },
  {
    name: "올리브영NFC수원오늘드림",
    spotCode: "10739",
  },
  {
    name: "올리브영NFC부평오늘드림",
    spotCode: "10759",
  },
];
